import PropTypes from "prop-types";
import React from "react";

export const Airplane2 = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M26.748,94h10l22.438-40H85c0,0,15,0,15-7s-15-7-15-7H59.186L36.748,0h-10l12.438,40H21.251L10,30H0l8,17L0,64h10 l11.252-10h17.935L26.748,94z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      style,
      viewBox: "0 0 100 94",
    };
  }
};

Airplane2.displayName = "Airplane2Icon";

Airplane2.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Airplane2.defaultProps = { role: "img" };
